(function (angular) {
    'use strict';

    /**
     * Provides an interface to the posts search API endpoint
     * 
     * @param {*} $resource 
     * @param {*} settings 
     */
    function postsSearchApi(
        $resource,
        settings
    ) {
        var resource = $resource(settings.apiBase + '/posts/search');
        return resource;
    }
    postsSearchApi.$inject = [
        '$resource',
        'settings',
    ];

    angular.module('app')
        .service('PostsSearchApi', postsSearchApi);
})(angular);
